import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DigDaysDataService from "../../services/DigDaysDataService";
import { notify } from "../../assets/utils/UtilsFunctons";

export const getAllDigDays = createAsyncThunk("DigDays/getAllDigDays", async () => {
  try {
    const response = await DigDaysDataService.getAllDigDays();
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

export const createDigDay = createAsyncThunk("DigDays/createDigDay", async (data) => {
  try {
    const response = await DigDaysDataService.createDigDay(data);
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

export const updateUserDigDaysStock = createAsyncThunk("DigDays/updateUserDigDaysStock", async (data) => {
  try {
    const response = await DigDaysDataService.updateUserDigDaysStock(data);
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

export const getDigDaysByUserId = createAsyncThunk("DigDays/getDigDaysByUserId", async (id) => {
  try {
    const response = await DigDaysDataService.getDigDaysByUserId(id);
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

export const digDayDecision = createAsyncThunk("DigDays/digDayDecision", async (data) => {
  try {
    const response = await DigDaysDataService.digDayDecision(data);
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

export const updateDigDay = createAsyncThunk("DigDays/updateDigDay", async (data) => {
  try {
    const response = await DigDaysDataService.updateDigDay(data);
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

export const cancelDigDay = createAsyncThunk("DigDays/cancelDigDay", async (data) => {
  try {
    const response = await DigDaysDataService.cancelDigDay(data);
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

const DigDaysSlice = createSlice({
  name: "digDays",
  initialState: {
    digDays: undefined,
    loading_getAllDigDays: false,
    createDigDay: undefined,
    loading_createDigDay: false,
    digDaysByUserId: undefined,
    loading_getDigDaysByUserId: false,
    decison: undefined,
    loading_digDayDecision: false,
    cancel: undefined,
    loading_cancelDigDay: false,
    refreshDigDaysPage: false,
    updateUserDigDaysStock: undefined,
    loading_updateUserDigDaysStock: false,
    updateDigDay: undefined,
    loading_updateDigDay: false,
  },
  reducers: {},
  extraReducers: {
    [createDigDay.pending]: (state) => {
      state.loading_createDigDay = true;
    },
    [createDigDay.fulfilled]: (state, { payload }) => {
      state.loading_createDigDay = false;
      state.createDigDay = payload;
      if (payload?.status === 200) {
        notify(1, "DigDay créé avec succès");
        state.refreshDigDaysPage = !state.refreshDigDaysPage;
      } else if (payload?.title) {
        notify(0, payload.title);
      }
    },
    [getAllDigDays.pending]: (state) => {
      state.loading_getAllDigDays = true;
    },
    [getAllDigDays.fulfilled]: (state, { payload }) => {
      state.loading_getAllDigDays = false;
      state.digDays = payload;
      if (payload?.status !== 200 && payload?.title) {
        /* No action if status === 200, so we check for errors only */
        notify(0, payload.title);
      }
    },
    [getDigDaysByUserId.pending]: (state) => {
      state.loading_getDigDaysByUserId = true;
    },
    [getDigDaysByUserId.fulfilled]: (state, { payload }) => {
      state.loading_getDigDaysByUserId = false;
      state.digDaysByUserId = payload;
      if (payload?.status !== 200 && payload?.title) {
        /* No action if status === 200, so we check for errors only */
        notify(0, payload.title);
      }
    },

    [updateUserDigDaysStock.pending]: (state) => {
      state.loading_updateUserDigDaysStock = true;
    },
    [updateUserDigDaysStock.fulfilled]: (state, { payload }) => {
      state.loading_updateUserDigDaysStock = false;
      state.updateUserDigDaysStock = payload;
      if (payload?.status !== 200 && payload?.title) {
        /* No action if status === 200, so we check for errors only */
        notify(0, payload.title);
      }
    },

    [digDayDecision.pending]: (state) => {
      state.loading_digDayDecision = true;
    },
    [digDayDecision.fulfilled]: (state, { payload }) => {
      state.loading_digDayDecision = false;
      state.decison = payload;
      if (payload?.status === 200) {
        notify(1, "décision enregistrée avec succès");
        state.refreshDigDaysPage = !state.refreshDigDaysPage;
      } else if (payload?.title) {
        notify(0, payload.title);
      }
    },
    [cancelDigDay.pending]: (state) => {
      state.loading_cancelDigDay = true;
    },
    [cancelDigDay.fulfilled]: (state, { payload }) => {
      state.loading_cancelDigDay = false;
      state.cancel = payload;
      if (payload?.status === 200) {
        notify(1, "digDay annulé avec succès");
        state.refreshDigDaysPage = !state.refreshDigDaysPage;
      } else if (payload?.title) {
        notify(0, payload.title);
      }
    },
    [updateDigDay.pending]: (state) => {
      state.loading_updateDigDay = true;
    },
    [updateDigDay.fulfilled]: (state, { payload }) => {
      state.loading_updateDigDay = false;
      state.updateDigDay = payload;
      if (payload?.status === 200) {
        notify(1, "DigDay modifié avec succès");
        state.refreshDigDaysPage = !state.refreshDigDaysPage;
      } else if (payload?.title) {
        notify(0, payload.title);
      }
    },
  },
});

export default DigDaysSlice.reducer;
